export default el => {
	let submitted = false;
	el.addEventListener('submit', event => {

	if (!submitted) {
		// IE11-Bug. Multiselects have to be transformed to hidden inputs to send data with form.
		Array.from(el.querySelectorAll('[data-handle-before-submit]')).forEach($select => {
			Array.from($select.querySelectorAll('option')).forEach($option => {
				const $input = document.createElement('input');

				$input.setAttribute('type', 'hidden');
				$input.name = $select.name;
				$input.value = $option.value;

				$select.parentNode.appendChild($input);
			});
			$select.parentNode.removeChild($select);
		});

		const buttons = [].slice.call(el.querySelectorAll('button'));

		buttons.forEach(button => button.setAttribute('disabled', 'disabled'));
			submitted = true;
		} else {
			event.preventDefault();
		}
	});
}
